import React from 'react'
import styled from 'styled-components'

interface Props {
  children?: React.ReactNode
}

/**
 * Subheading 2
 */
const SubH2 = ({
  children,
}: Props) => {
  return (
    <CustomText
      children={children}
    />
  )
}

export default SubH2

const CustomText = styled.div`
  color: var(--gray-c2);
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 100%;
`;
